import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { VesselVisitWebcomponentModule } from './app/vessel-visit-webcomponent/vessel-visit-webcomponent.module';

enableProdMode();

platformBrowserDynamic()
    .bootstrapModule(VesselVisitWebcomponentModule)
    .catch((err) => console.error(err));
